<template>
    <form id="tipoForm" @submit.prevent="submit" class="ajax_off">
        <div class="form-group">
            <label>Nome do tipo de serviço</label>
            <input type="text" name="nome" class="form-control" v-model="tipo.nome" required />
        </div>

        <div class="form-group">
            <label>Departamento</label>
            <e-select name="departamento_id" v-model.number="tipo.departamento_id" route="time" />
        </div>

        <div class="form-group">
            <label>Preço</label>
            <money name="preco" v-model="tipo.preco" class="form-control"></money>
        </div>

        <div class="form-group">
            <label>Prazo em dias para executar</label>
            <input type="number" class="form-control" v-model="tipo.prazo_execucao" required />
        </div>



        <div class="form-group">
            <label>Crédito em dias para usar o econsulte</label>
            <input type="number" class="form-control" v-model="tipo.credito_dias" required />
        </div>

        <b-form-checkbox v-model="tipo.status" name="check-button" switch>
            <b>Status: {{ tipo.status ? "ativo" : "inativo" }}</b>
        </b-form-checkbox>

        <b-form-checkbox v-model="tipo.solicitar_anexo" name="check-button" switch>
            <b>Solicitar Anexo</b>
        </b-form-checkbox>

        <div class="form-group" v-if="tipo.solicitar_anexo">
            <div class="form-group" v-for="(anexos, index) in tipo.tipos_anexos" :key="index">
                <label>Nome do documento solicitado:</label>
                <input type="text" class="form-control" v-model="tipo.tipos_anexos[index].text" />
            </div>
            <b-button type="button" variante="success" @click.prevent="addSolicitarDocumento()"><i class="fas fa-plus"></i>
                Solicitar outro documento</b-button>
        </div>
    </form>
</template>

<script>
import { mapMutations } from "vuex";
export default {
    props: {
        servico_id: Number
    },
    data() {
        return {
            tipo: {
                departamento_id: null,
                ativar_upload: 0,
                status: true,
                solicitar_anexo: false,
                tipos_anexos: [],
            },
        };
    },
    watch: {
        "tipo.solicitar_anexo": function (newValue) {

            if (newValue) {
                this.tipo.tipos_anexos.push({ text: "" });
                this.solicitar_anexo = 1;
            } else {
                this.tipo.tipos_anexos = [];
                this.solicitar_anexo = 0;
            }
        },
    },
    created() {
        if (this.servico_id)
            this.getServico();
    },
    methods: {
        ...mapMutations("datatable", ["setReload"]),
        addSolicitarDocumento() {
            this.tipo.tipos_anexos.push({ text: "" });
        },
        async submit() {
            if (this.servico_id){
                await this.$api.put(`tipos-de-servico/${this.servico_id}`, this.tipo);
            }else{
                await this.$api.post('tipos-de-servico', this.tipo);
            }

            this.setReload();
            this.$bvModal.hide('tipo-de-servico');
        },
        async getServico() {
            const result = await this.$api.get(`tipos-de-servico/${this.servico_id}`);

            this.tipo = result.data;
        }
    },
};
</script>
